var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFormaldehyde(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M30.5 49C36.299 49 41 44.299 41 38.5S36.299 28 30.5 28 20 32.701 20 38.5 24.701 49 30.5 49zm0-3.15a7.35 7.35 0 100-14.7 7.35 7.35 0 000 14.7zM30.5 24a8.5 8.5 0 100-17 8.5 8.5 0 000 17zm0-2.833a5.667 5.667 0 100-11.334 5.667 5.667 0 000 11.334z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 15.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 53a5 5 0 100-10 5 5 0 000 10zm0-2a3 3 0 100-6 3 3 0 000 6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M23 43.35L16.56 47 15 44.65 21.44 41 23 43.35zM49 53a5 5 0 110-10 5 5 0 010 10zm0-2a3 3 0 110-6 3 3 0 010 6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M38 43.35L44.44 47 46 44.65 39.56 41 38 43.35zM28 30.16V23h2.044v7.16H28zM31 30.16V23h2.044v7.16H31z"
  })));
}

export default SvgIconFormaldehyde;